import * as React from 'react'
import QueryString from 'query-string'
import { forEach, find, includes } from 'lodash'
import Promise from 'bluebird'
import { renderMarkdown } from '../../util'
import { withConfig } from  '../config'
import cobrandActions from './cobrand-actions'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

/*

Interacts with contentful.com and supplies the required data for the appropriate cobrand. This data 
is typically displayed in the components/header and components/footer components.

When the wrapped component mounts, the requestCoband() action is fired. requestCobrand() will perform
these operations:
    - check to see if the cobrand data has already loaded. If it has, exit early
    - check to see if a query parameter named "referenceCode" exists in the address bar
    - make a request to contentful.com, and get all the cobrand data
    - filter the data to the single entry that matches the referenceCode
    - check to see if the referenceCode is enabled for the form project
    - populate the state with the relevant cobrand entry via the supplyCobrand() action

Wrapped components can simply check against the state.cobrand state for the existence of the nessessary 
data.

*/

function mapStateToProps(state, intialProps){
    return {
        ...intialProps,
        cobrand: state.cobrand
    }
}


function mapDispatchToProps(dispatch, props){
    return {
        actions:{
            ...props.actions,
            cobrand: bindActionCreators(cobrandActions, dispatch)
        }
    }
}


export function withCobrand(WrappedComponent){
    
    return connect(mapStateToProps, mapDispatchToProps)(class extends React.Component<any, any>{

        componentDidMount(){
            this.props.actions.cobrand.requestCobrand()
        }

        render(){
            return <WrappedComponent { ...this.props } />
        }

    })

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/cobrand/index.tsx